import gql from 'graphql-tag';

export const IMAGE_OR_VIDEO_CREATIVE_TEMPLATES = gql`
  query ImageOrVideoCreativeTemplates($articleGroupId: ID!) {
    imageOrVideoCreativeTemplates(articleGroupId: $articleGroupId) {
      id
      sourceType
      callToAction
      hasCreatives
      hasFacebookAds
      videoId
      imageType
      createdAt
      imageId
      origin {
        creationMethod
        anywordTemplateName
        postTextSource {
          source
          anywordTemplateId
          anywordTemplateName
        }
        headlineSource {
          source
          anywordTemplateId
          anywordTemplateName
        }
      }
      image {
        id
        url
      }
      postText {
        id
        text
      }
      headline {
        id
        text
      }
      description {
        id
        text
      }
    }
  }
`;
